import styled from "styled-components";
import { colors } from "../ui/globalColors";

export const PdfTableReportRenderStyled = styled.div`
    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px 20px;
        width: ${({ orientation }) => orientation == 'l' ? '594mm' : 'auto'}; // 297*2 (A4 height)

        .pdf-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-bottom: 10px;

            .logo {
                height: 50px;
    
                img {
                    height: 100%;
                }
            }
        }
    
        .pdf-title {
            font-size: 20px;
            text-align: center;
            font-weight: 700;
            border-bottom: 1px solid black;
            width: fit-content;
        }

        .pdf-title.address {
            margin-bottom: 20px;
        }
    
        .pdf-rows-wrapper {
            width: 100%;
            
            .pdf-row {
                direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
                display: flex;
                padding: 10px;
                gap: 5px;
    
                :nth-child(2n) {
                    background-color: ${colors.additionalColors.lightGray};
                }
    
                div {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                }
                
                .row-cell {
                    flex-basis: ${({ cells }) => `calc(100% / ${cells})`};
                    max-width: ${({ cells }) => `calc(100% / ${cells})`};
                    overflow-wrap: anywhere;
                }
    
                .pdf-highlited {
                    font-weight: 700;
                    font-size: 16px;
                }
            }
    
            @media print {
                .pdf-row {
                    padding-inline-start: 10px;
                }
            }
        }
        
        .pdf-footer {
            margin-top: 20px;
            text-align: end;
            width: 100%;
        }
    }
`
